import { INSTAGRAM_URL } from '../../config/site';

// TODO: replace the placeholder grid with real cake photos (e.g. from the IG feed).
const GALLERY_ITEMS = Array.from({ length: 6 });

export default function Gallery() {
  return (
    <section id="gallery" className="py-16 md:py-24 bg-cream scroll-mt-[132px]">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary text-center mb-12 md:mb-16">
          THE GALLERY
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {GALLERY_ITEMS.map((_, i) => (
            <div key={i} className="bg-card-bg aspect-square flex items-center justify-center">
              <span className="text-text-muted/50 text-xs tracking-widest uppercase">Photo</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-inter text-xs tracking-[0.2em] uppercase text-text-primary no-underline border-b-2 border-sage pb-1 hover:opacity-80 transition-opacity"
          >
            SEE MORE ON INSTAGRAM
          </a>
        </div>
      </div>
    </section>
  );
}
